import LogService from "../CommonSdk/LogService";
import * as ErrorUtils from "../Utils/ErrorUtils";
import RainbowServerFetch from "../Request/RainbowServerFetch";
import * as CountriesUtils from "../Utils/CountriesUtils";

const LOG_TAG = "SERVICE:COMPANY";

export const createCompany = (companyName, countryCode, stateCode) => {
    LogService.trace(LOG_TAG, "createCompany");

    if (!companyName || companyName.length === 0) {
        return Promise.reject(ErrorUtils.parseErrorAndReturnPayload("no company name"));
    }

    let parameters = {
        name: companyName,
        country: countryCode
    };

    if (CountriesUtils.isCanadianOrUsaCountry(countryCode)) {
        parameters.state = stateCode;
    }

    const body = JSON.stringify(parameters);

    return RainbowServerFetch.post("/api/rainbow/enduser/v1.0/companies", body)
        .then(response => {
            LogService.info(LOG_TAG, "createCompany", "success", response);
            return Promise.resolve(response);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "createCompany", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}

export const getCompanyData = (id) => {
    LogService.trace(LOG_TAG, "getCompanyData");

    return RainbowServerFetch.get("/api/rainbow/enduser/v1.0/companies/" + id)
        .then(company => {
            LogService.info(LOG_TAG, "getCompanyData", "success", company);
            return Promise.resolve(company.data);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "getCompanyData", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}
